<template>
    <div>
        <page-title>{{ title }}</page-title>
        <company-route-tabs
            v-if="isSuperAdmin"
            :company-id="companyId"
        ></company-route-tabs>
        <company-addresses-table :company-id="companyId">
            <template v-slot:actions>
                <create-button
                    :route-name="routeType.COMPANY_ADDRESS_CREATE"
                ></create-button>
            </template>
        </company-addresses-table>
    </div>
</template>

<script>
import routeType from '@/router/routeType'
import SelectApiClienType from '@/api/SelectApiClientType'
import TitleMixinGenerator from '@/components/mixins/page-title/TitleMixinGenerator'
import AuthMixin from '@/components/mixins/AuthMixin'
import CreateButton from '@/components/form/Actions/CreateButton'
import CompanyRouteTabs from '@/components/pages/companies/RouteTabs'
import CompanyAddressesTable from '@/components/pages/companyAddresses/Table'

export default {
    components: {
        CreateButton,
        CompanyRouteTabs,
        CompanyAddressesTable,
    },
    mixins: [
        TitleMixinGenerator(SelectApiClienType.COMPANY, 'companyId'),
        AuthMixin,
    ],
    props: {
        companyId: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            routeType,
        }
    },
}
</script>
